import { useState } from "react";
import { db } from "../../lib/firebase"; 
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
import { toast } from "react-toastify";

export const useAddToWarpList = () => {
  const [isLoading, setIsLoading] = useState(false);

  const addToWarpList = async (email) => {
    // 1. Basic validation
    if (!email || !email.includes("@")) {
      toast.error("Please enter a valid email address.");
      return false;
    }

    const cleanedEmail = email.toLowerCase().trim();
    setIsLoading(true);

    try {
      // 2. Reference a document using the email as the ID
      const docRef = doc(db, "warplist", cleanedEmail);
      
      // 3. Check if this email already exists
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        toast.info("You're already on the list! 🚀");
        setIsLoading(false);
        return true; // Return true to clear the input anyway
      }

      // 4. If not exists, create it
      await setDoc(docRef, {
        email: cleanedEmail,
        createdAt: serverTimestamp(),
      });

      toast.success("Welcome to the Warp List!");
      return true;
    } catch (error) {
      console.error("Error adding to Warp List:", error);
      toast.error("Something went wrong. Please try again.");
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { addToWarpList, isLoading };
};